import {PropsWithChildren} from "react";
import {useTranslation} from "react-i18next";
import {Stack, Typography} from "@mui/material";
import {useCompany} from "../hooks/companiesHooks";

export interface Props extends PropsWithChildren {
    header: React.ReactNode;
    errorContent?: React.ReactNode;
}

export const MainViewLayout: React.FC<Props> = ({children, header, errorContent}) => {
    const {t} = useTranslation();
    const company = useCompany();

    return (
        <>
            <Stack direction="column" paddingX="3rem" paddingTop="3rem" paddingBottom="0.5rem" gap="2.25rem">
                {header}
                {company?.data && <Stack direction="column">{errorContent ? errorContent : children}</Stack>}
                {!errorContent && company.isError && <Typography>{t("main_view_layout.has_error")}</Typography>}
                {!errorContent && company.isSuccess && !company.data && (
                    <Typography>{t("main_view_layout.has_no_company")}</Typography>
                )}
            </Stack>
        </>
    );
};
